<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <wapi-panel :title="'Список параметров'">
          <template v-slot:content>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="domain in domains" :key="domain.name">
                <v-expansion-panel-header>{{ domain.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Тип уровня</th>
                          <th>Уровень</th>
                          <th>Имя параметра</th>
                          <th>Короткое имя</th>
                          <th>Ед. измерения</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="parameter in domain.parameters" v-bind:key="parameter.id">
                          <th>{{ parameter.level_type }}</th>
                          <td>{{ parameter.level }}</td>
                          <td>{{ parameter.pname }}</td>
                          <td>{{ parameter.sname }}</td>
                          <td>
                            <v-chip class="ma-2">{{ parameter.unit }}</v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiPanel from "../components/WapiPanel";

export default {
  name: "ParametersView",
  title: "Параметры",
  components: {
    WapiPanel
  },
  data() {
    return {
      parameters: [],
      domains: []
    };
  },
  async created() {
    await this.$store.dispatch("SET_LOADING", true);
    this.domains = await this.$store.dispatch("FETCH_DOMAINS");

    this.domains.forEach(async d => {
      d["parameters"] = await this.$store.dispatch("FETCH_PARAMETERS", {
        domain: d.name
      });
    });
    await this.$store.dispatch("SET_LOADING", false);
  }
};
</script>